module.exports = __webpack_public_path__ + "assets/media/error.fc96ac6f.svg";